import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastyService } from 'ng2-toasty';
import { Subscription } from 'rxjs';
import { AuthService } from '../../seguranca/auth.service';
import { LogoutService } from '../../seguranca/logout.service';
import { ErrorHandlerService } from '../error-handler.service';
import { UsuarioHasEntidade } from '../model/usuarioHasEntidade.model';
import { UsuarioHasEntidadeFiltro, UsuarioHasEntidadeService } from '../usuarioHasEntidade.service';
import { safeUpdate } from '../utils/change-detection-safe';
import { TrocaEntidadeService } from '../services/troca-entidade.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { NotificacaoHasUsuarioFiltro, NotificacaoHasUsuarioService } from './../services/notificacao/notificacaoHasUsuario.service';

declare let AdminLTE: any;

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  contadorNotificaoNaoLidas;
  listaNotificacaoHasUser;

  // ==== TROCA DE UNIDADE/ENTIDADE ==== //
  listaVinculos: any[] = [];
  listaVinculosView: any[] = [];
  openModalEntidades = false;
  openModalEntidadesView = false;
  private solicitarAberturaSubscription: Subscription;

  constructor(
    public auth: AuthService,
    private logoutService: LogoutService,
    private errorHandler: ErrorHandlerService,
    private router: Router,
    private toasty: ToastyService,
    private notificacaoHasUsuarioService: NotificacaoHasUsuarioService,
    private usuarioHasEntidadeService: UsuarioHasEntidadeService,
    private usuarioService: UsuarioService,
    private trocaEntidadeService: TrocaEntidadeService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.listarNotificacoesHasUser(this.auth.jwtPayload.id);
    this.pesquisarEntidadesVinculadas(this.auth.jwtPayload.id);

    this.solicitarAberturaSubscription = this.trocaEntidadeService.solicitarAbertura$.subscribe(() => {
      this.abrirModalTrocaEntidade();
    });
  }

  ngOnDestroy() {
    this.solicitarAberturaSubscription?.unsubscribe();
  }

  logout() {
    this.logoutService.logout()
      .then(() => {
        this.router.navigate(['/login']);
      })
      .catch(erro => this.errorHandler.handle(erro));
  }

  listarNotificacoesHasUser(idUsuario) {
    this.contadorNotificaoNaoLidas = 0
    let filtroNotificacaoHasUsuario = new NotificacaoHasUsuarioFiltro;
    filtroNotificacaoHasUsuario.usuario = idUsuario
    this.notificacaoHasUsuarioService.pesquisar(filtroNotificacaoHasUsuario).then(lista => {
      this.listaNotificacaoHasUser = lista.content
      this.listaNotificacaoHasUser.forEach(element => {
        if (element.statusNotificacao != "Lida") {
          this.contadorNotificaoNaoLidas++
        }
      });
    }).catch(erro => this.errorHandler.handle(erro));
  }

  async pesquisarEntidadesVinculadas(idUsuario: any) {
    let filtro = new UsuarioHasEntidadeFiltro();
    filtro.usuario = idUsuario;
    filtro.itensPorPagina = 100;
    await this.usuarioHasEntidadeService.pesquisar(filtro).then((resultado: any) => {
      this.listaVinculos = resultado.content || [];
      safeUpdate(() => {
        this.listaVinculosView = [...this.listaVinculos];
        this.cdr.detectChanges();
      });
    }).catch(erro => this.errorHandler.handle(erro));
  }

  abrirModalTrocaEntidade() {
    this.pesquisarEntidadesVinculadas(this.auth.jwtPayload.id).then(() => {
      if (this.listaVinculos.length > 1) {
        this.atualizarVisibilidadeModalEntidades(true);
      }
    });
  }

  onModalEntidadesVisibleChange(visible: boolean): void {
    this.atualizarVisibilidadeModalEntidades(visible);
  }

  private atualizarVisibilidadeModalEntidades(visible: boolean): void {
    safeUpdate(() => {
      this.openModalEntidades = visible;
      this.openModalEntidadesView = visible;
      this.cdr.detectChanges();
    });
  }

  atualizarEntidadePrincipal(item: UsuarioHasEntidade) {
    //SETAR ENTIDADE ANTIGA COMO NÃO PRINCIPAL
    let entidadeAntiga = this.listaVinculos.filter((x) => x.principal)[0];
    entidadeAntiga.principal = false;
    let entidadeNova = item;
    entidadeNova.principal = true;
    this.atualizarUsuarioHasEntidade(entidadeAntiga);
    this.atualizarUsuarioHasEntidade(entidadeNova);

    let usuario = this.listaVinculos[0].usuario;
    let atualizacaoEntidade: Promise<any>;
    if (item.entidadeConcedente) {
      atualizacaoEntidade = this.usuarioService.atualizarUsuarioConcedente(
        usuario,
        usuario.id,
        item.entidadeConcedente.id
      );
    } else if (item.entidadeProponente) {
      atualizacaoEntidade = this.usuarioService.atualizarUsuarioProponente(
        usuario,
        usuario.id,
        item.entidadeProponente.id
      );
    }

    if (atualizacaoEntidade) {
      atualizacaoEntidade
        .then(() => this.auth.obterNovoAccessToken())
        .then(() => {
          this.toasty.success("Entidade Principal Atualizada com sucesso!");
          this.atualizarVisibilidadeModalEntidades(false);
          window.location.reload();
        })
        .catch((erro) => this.errorHandler.handle(erro));
    }
  }

  atualizarUsuarioHasEntidade(usuarioHasEntidade: UsuarioHasEntidade) {
    this.usuarioHasEntidadeService.atualizar(usuarioHasEntidade).then(() => {
      this.pesquisarEntidadesVinculadas(this.auth.jwtPayload.id);
    });
  }

}
